import React from 'react'

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Checkbox,
    FormControlLabel,
    Grid,
    TextField,
    Typography
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const AccordionAssitant = ({ assitant, tours, index, handleChange }) => {
    const allTourIds = (Array.isArray(tours) ? tours : [])
        .map((tour) => tour?.slug || tour?.id)
        .filter(Boolean)

    const selectedTours = Array.isArray(assitant?.tours) ? assitant.tours : []
    const allSelected = allTourIds.length > 0 && allTourIds.every((tourId) => selectedTours.includes(tourId))

    return (
        <Accordion
            sx={{
                border: '1px solid #223F7F',
                boxShadow: 'none',
                my: '10px',
                borderRadius: '8px!important'
            }}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                sx={{
                    py: '6px',
                    color: 'secondary.main'
                }}>
                Pasajero {index + 1}
            </AccordionSummary>
            <AccordionDetails>
                <form>
                    <Grid
                        container
                        spacing={3}
                        sx={{
                            '& .MuiInputBase-input': {
                                p: '7px 10px',
                                bgcolor: '#F9FAFB',
                                border: '1px solid #F9FAFB'
                            }
                        }}>
                        <Grid item xs={12} md={6} sx={{ display: 'grid' }}>
                            <label htmlFor="name">Nombre*</label>
                            <TextField
                                name="name"
                                type="text"
                                placeholder="Introduce..."
                                value={assitant.name}
                                onChange={handleChange}
                                sx={{
                                    p: 0
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} sx={{ display: 'grid' }}>
                            <label htmlFor="secondName">Apellidos*:</label>
                            <TextField
                                name="lastName"
                                type="text"
                                placeholder="Introduce..."
                                value={assitant.lastName}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} md={12} sx={{ display: 'grid' }}>
                            <label htmlFor="message">Pasaporte*</label>
                            <TextField
                                name="passport"
                                type="text"
                                placeholder="Introduce..."
                                value={assitant.passport}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>
                </form>
                <Box sx={{ pt: '20px' }}>
                    <Typography variant="body2" component="p">
                        ¿A que tour va? (Señala los tours a los que está incluido este asistente)*
                    </Typography>
                    <Box sx={{ pl: '10px', display: 'grid' }}>
                        <FormControlLabel
                            value="all"
                            label="Todos los tours"
                            sx={{
                                '& .MuiFormControlLabel-label': {
                                    fontSize: '12px'
                                }
                            }}
                            control={
                                <Checkbox
                                    checked={allSelected}
                                    onChange={() => handleChange({ target: { name: 'tourSelectionToggle', value: 'all' } })}
                                    value="all"
                                    inputProps={{ 'aria-label': 'Todos' }}
                                />
                            }
                        />
                        {(Array.isArray(tours) ? tours : []).map((tour) => {
                            const tourId = tour?.slug || tour?.id
                            if (!tourId) return null

                            return (
                                <FormControlLabel
                                    key={tourId}
                                    value={tourId}
                                    label={tour?.title || tour?.name || tourId}
                                    sx={{
                                        '& .MuiFormControlLabel-label': {
                                            fontSize: '12px'
                                        }
                                    }}
                                    control={
                                        <Checkbox
                                            checked={selectedTours.includes(tourId)}
                                            onChange={() => handleChange({ target: { name: 'tourSelectionToggle', value: tourId } })}
                                            value={tourId}
                                            inputProps={{ 'aria-label': tourId }}
                                        />
                                    }
                                />
                            )
                        })}
                    </Box>
                </Box>
            </AccordionDetails>
        </Accordion>
    )
}

export default AccordionAssitant
